module.exports = __webpack_public_path__ + "img/isle-of-man.11130526.png";